import { Injectable } from "@angular/core";
import { ApiClientService } from "src/app/@core/services/api-client.service";
import { BaseFucntionsService } from "src/app/@core/services/base-functions.service";
import { ApplicationRoutes } from "src/app/@core/routes/application-routes.const";
import { TestimonialModel } from "../models/testimonial.model";

@Injectable({
    providedIn: 'root',
})

export class TestimonialService extends BaseFucntionsService<TestimonialModel> {

    constructor(apiClient: ApiClientService) {
        super(ApplicationRoutes.Testimonial.Controller, apiClient);
    }
    getActiveList() {
        return this.apiClient.get(`${ApplicationRoutes.Testimonial.Active}`);
    }
}

